module.exports = __webpack_public_path__ + "static/media/lock.32000f1a.svg";